import { clearCredentials } from 'features/auth/authSlice'
import { clearCredentials as clearMOCredentials } from 'features/client/services/userSlice'
import { baseApi } from 'common/store/baseApi'
import { memberApi } from 'features/client/services/member'

export const useHandleLogout = (dispatch: any) => {
  const handleLogout = () => {
    dispatch(clearCredentials())
    dispatch(baseApi.util.resetApiState())
  }

  return {
    handleLogout,
  }
}

export const useHandleLogoutMO = (dispatch: any) => {
  const handleLogoutMO = () => {
    dispatch(clearMOCredentials())
    dispatch(memberApi.util.resetApiState())
  }
  return handleLogoutMO()
}
